export default "__VITE_ASSET__D0m2LLcL__"